import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addExpenseClaimSubmit = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Expense Claim',
    body
  );
  return data;
});
export const updateExpenseClaimSubmit = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Expense Claim/${id}`,
    body
  );
  return data;
});

export const getExpenseClaimSubmit = catchAsync(
  async ({ key = '', value = '' }) => {
    let baseUrl =
      '/api/resource/Expense Claim?fields=["name","docstatus","status","employee_name","department","total_sanctioned_amount","total_claimed_amount"]&order_by=name desc&limit_start=0&limit_page_length=0';
    if (value) {
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
    }
    const { data } = await axiosInstance.get(baseUrl);
    return data;
  }
);
export const deleteExpenseClaimSubmit = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Expense Claim/${record}`
  );
  return data;
});
export const getExpenseClaimDetailsSubmit = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Expense Claim/${id}`);
  return data;
});
export const getCompanyInfoClaim = catchAsync(async (Company) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_data?type=Company&name=${Company}&fields=["default_expense_claim_payable_account","cost_center"]`
  );
  return data;
});
export const getEmployeeAdvanceInfo = catchAsync(async (body) => {
  // console.log(body, 'employeevvvvvvvvvvvvvvvvvvbbbbbbbbbbbbbbbb');

  const { data } = await axiosInstance.get(
    `/api/resource/Employee Advance?fields=["name","posting_date","paid_amount","claimed_amount","return_amount","advance_account"]&filters=[["status","=","paid"],["employee","=","${body.employee}"]]`
  );
  return data;
});
